(function(){
  const hasPurchased = localStorage.getItem("gf_hasPurchased");
  const hasReviewed  = localStorage.getItem("gf_reviewed");

  if(hasPurchased === "yes" && hasReviewed !== "yes"){
    setTimeout(function(){
        const productURL = localStorage.getItem("gf_last_product_url");
console.log("gf_last_product_url:", productURL);

const reviewURL = productURL ? productURL + "#judgeme_product_reviews" : "/collections/all";
console.log('reviewURL:', reviewURL);

    //   const productURL = localStorage.getItem("gf_last_product_url");
    //   const reviewURL = productURL ? productURL + "#judgeme_product_reviews" : "/collections/all";


      const popup = document.createElement("div");
      popup.id = "gfReviewPopup";
      popup.style.cssText = "position:fixed;inset:0;background:#0008;z-index:99999;display:flex;align-items:center;justify-content:center;";

      popup.innerHTML = `
        <div style="max-width:420px;background:#fff;color:#000;padding:26px;border-radius:16px;text-align:center;">
          <h3>Thanks for shopping with Girafits 🙌</h3>
          <p>Help other buyers by leaving a review and get <b>5% OFF</b> your next order!</p>
          <a id="gfReviewBtn" href="${reviewURL}" style="display:block;margin:15px 0;background:#000;color:#fff;padding:12px;border-radius:8px;text-decoration:none;">Leave Review</a>
          <button id="gfClose" style="background:none;border:none;color:#555;cursor:pointer;">Maybe later</button>
        </div>
      `;

      document.body.appendChild(popup);
      document.getElementById("gfClose").onclick = () => popup.remove();

    }, 2000);
  }
})();
